import Icon from '../../components/Icon.vue'

Icon.register({"brands/firstdraft":{"width":384,"height":512,"paths":[{"d":"M384 192H320V320H192V448H0V422.4H166.4V294.4H294.4V166.4H384V192zM358.4 230.4V358.4H230.4V486.4H64V512H256V384H384V230.4H358.4zM384 422.4H294.4V512H320V448H384V422.4zM0 0V384H128V256H256V128H384V0H0z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/firstdraft.js
// module id = null
// module chunks = 